import { fork } from 'redux-saga/effects';
import { appSaga } from '../app/saga';
import { loginSaga } from '../page/Login/saga';
import { searchSaga } from '../page/Search/saga';
import { searchOverseasSaga } from '../page/SearchOverseas/saga';
import { sideMenuSaga } from '../components/SideMenu/saga';
import { userManagementSaga } from 'page/UserManagement/saga';
import partnerUsersSaga from 'page/PartnerUsers/sagas';
import { hubManagementSaga } from 'page/HubManagement/saga';
import { workflowSaga } from 'page/WorkFlowManagement/saga';
import { productSaga } from 'page/ProductManagement/saga';
import { refundBatchConfigSaga } from 'page/RefundBatchConfig/saga';
import { auditSaga } from 'page/Audit/saga';
import { helperSaga } from 'utils/Helper/saga';
import { requestFlowSaga } from 'page/RequestMessages/saga';

export function* rootSaga() {
  yield fork(appSaga);
  yield fork(loginSaga);
  yield fork(searchSaga);
  yield fork(searchOverseasSaga);
  yield fork(sideMenuSaga);
  yield fork(userManagementSaga);
  yield fork(hubManagementSaga);
  yield fork(workflowSaga);
  yield fork(productSaga);
  yield fork(refundBatchConfigSaga);
  yield fork(auditSaga);
  yield fork(helperSaga);
  yield fork(requestFlowSaga);
  yield fork(partnerUsersSaga);
}
